import { BasicClient } from '@/utils/httpClient';
import {param} from "jquery";

export default class Signature {
  client: BasicClient
  constructor() {
    this.client = new BasicClient();
  }

  setSignaturePosition(id: any, body: any, flag = false) {
    return this.client.exec(`/v2/signaturePosition/${id}`, 'POST', body, flag)
  }

  setSignatureDefault(id: any) {
    return this.client.exec(`/v2/signaturePositionDefault/${id}`, 'PUT')
  }

  getPreviewPositionImage(id: any) {
    return this.client.exec(`/v2/signaturePositionThumbnail/${id}`, 'GET')
  }

  removeSignaturePosition(id) {
    return this.client.exec(`/v2/signatureOmit/${id}`, 'PUT')
  }

  getSignaturePosition(id) {
    return this.client.exec(`/v2/signaturePositionCoordinates/${id}`, 'GET')
  }

  getSubFolderSignatures(id) {
    return this.client.exec(`/v2/subfolders/${id}/signatures`, 'GET')
  }

  getCustomFile(id) {
    return this.client.exec(`/v2/signaturePositionPreview/${id}`, 'GET')
  }

  getValidateCustomFile(file) {
    return this.client.exec(`/v2/signaturePosition/pdfInfo`, 'POST', { file }, true)
  }

  setCustomPresetPdf(params) {
    return this.client.setCropPdf(`/v2/subfolders/configfile`, params)
  }
}
